import React, { useState, useEffect } from 'react';

export default function TimePickerModal({ 
  isOpen, 
  onClose, 
  birthDetails, 
  handleBirthDetailsChange,
  selectedHour: propSelectedHour,
  setSelectedHour: propSetSelectedHour,
  selectedMinute: propSelectedMinute,
  setSelectedMinute: propSetSelectedMinute
}) {
  const [selectedHour, setSelectedHour] = useState(propSelectedHour);
  const [selectedMinute, setSelectedMinute] = useState(propSelectedMinute);

  useEffect(() => {
    if (isOpen) {
      // Parse existing birth_time if available
      if (birthDetails.birth_time) {
        const [hour, minute] = birthDetails.birth_time.split(':');
        setSelectedHour(hour);
        setSelectedMinute(minute);
      }
    }
  }, [isOpen, birthDetails.birth_time]);

  if (!isOpen) return null;

  const handleCancel = () => {
    setSelectedHour(null);
    setSelectedMinute(null);
    onClose();
  };

  const handleOk = () => {
    if (selectedHour !== null && selectedMinute !== null) {
      const formattedTime = `${selectedHour}:${selectedMinute}`;
      handleBirthDetailsChange('birth_time', formattedTime);
      
      // Update parent state if provided
      if (propSetSelectedHour) propSetSelectedHour(selectedHour);
      if (propSetSelectedMinute) propSetSelectedMinute(selectedMinute);
      
      onClose();
    }
  };

  return (
    <div className="picker-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="scroll-picker-modal">
        <div className="scroll-picker-header">
          <h3>Birth Time (24 Hrs)</h3>
        </div>
        <div className="scroll-picker-content">
          <div className="scroll-wheels">
            <div className="scroll-wheel">
              <div className="wheel-label">HOUR</div>
              <div className="wheel-container">
                {Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')).map(hour => (
                  <div 
                    key={hour} 
                    className={`wheel-item ${selectedHour === hour ? 'selected' : ''}`} 
                    onClick={() => setSelectedHour(hour)}
                  >
                    {hour}
                  </div>
                ))}
              </div>
            </div>

            <div className="scroll-wheel">
              <div className="wheel-label">MINUTE</div>
              <div className="wheel-container">
                {Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')).map(min => (
                  <div 
                    key={min} 
                    className={`wheel-item ${selectedMinute === min ? 'selected' : ''}`} 
                    onClick={() => setSelectedMinute(min)}
                  >
                    {min}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="picker-buttons">
          <button className="picker-btn picker-btn-cancel" onClick={handleCancel}>
            CANCEL
          </button>
          <button 
            className="picker-btn picker-btn-ok" 
            onClick={handleOk}
            disabled={selectedHour === null || selectedMinute === null}
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
